import React from 'react';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {Plugins, Atom} from '@packages/systems/wfdl';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const CommerceOptionLabel = Atom.createRender(
  ({
    attributes,
    classes,
    context,
    data,
    generateAttributes,
    innerHTML,
    renderChild,
  }) => {
    return (
      // TODO: fix jsx-a11y lint error
      // eslint-disable-next-line jsx-a11y/label-has-for
      <label {...generateAttributes(attributes, classes)}>
        {
          // TODO (platform): fix innerHTML type issues
          (innerHTML as any) ||
            getChildren(data).map((child: EvaluatedNodeData) =>
              renderChild(child, context)
            )
        }
      </label>
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'Field Label',
  showEmpty: true,
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Text')),
  },
  constraints: {
    ancestors: [
      {
        is: 'CommerceAddToCartOption',
        rule: 'ExactlyOne',
      },
    ],
  },
  render: CommerceOptionLabel,
  fields: {children: TListOfElement},
});

export default config;
